import { Link } from "react-router-dom";
import "../Css/Admin.css";
import "./css/List.css";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import DataRow from "./DataRow";

export default function DataList(props) {

    const sondage = props.sondage;
    const id = 0;
  return (
    <div className="data-container">
         <div className="data-grid">
        <div className="rows">
            <div className="column-titles row">
                <div className="name">Prénom et Nom</div>
                <div className="activity"> Cocktail ? </div>
                <div className="activity"> Repas ? </div>
                <div className="activity"> Brunch ? </div>
            </div>
                {
                sondage.map((line,index) =>(
                    <DataRow key={line.id_sondage} number={index} nom={line.nom} prenom={line.prenom} cocktail={line.cocktail} repas={line.repas} brunch={line.brunch}></DataRow>
                ))}
        </div>
    </div>    
    </div>    
   
  );
}